import { Controller } from "@hotwired/stimulus"
import { track } from "./analytics"

export default class extends Controller {
  static targets = ["formSubmit", "packageInput"]

  connect() {
    // Listen to click on venue packs to preselect in the snap quote
    document.querySelectorAll(".js-public-prices-table").forEach(element => {
      element.addEventListener("click", () => this.handlePackClick(element))
    })
  }

  handlePackClick(element) {
    // Select category tabs and pack value from snap quote
    const pack = element.dataset["pack"]
    const category = element.dataset["category"]
    const categoryTab = document.querySelector(`div[href="#${category}-form"]`)

    if (categoryTab !== null) {
      categoryTab.click()
      document.getElementById(`${category}_form_${pack}`).click()

      track("Clicked on Page", { name: "Pack Price", target_id: pack })
    }
  }

  submit() {
    this.formSubmitTarget.dataset["loader"] = true

    setTimeout(() => {
      this.formSubmitTarget.dataset["loader"] = false
    }, 1000)
  }
}
